import './../../../../../style/Vars.css';
import './../../../../../style/ContainersStyles.css';
import './../../../../../style/ElementsStyle.css';
import CarrerasCompartidasCatalog from './CarrerasCompartidasCatalog';

export default function CarrerasCompartidasPage() {
    return <CarrerasCompartidasCatalog />;
}
